import { Input, DatePicker } from "antd";
import React, { useState, useCallback } from "react";
import { Moment } from "moment";
import useLocale from "../../hooks/use-locale";

interface SingleNameProps {
  salesType: string;
  index: number;
  onValidation: (salesType: string, index: number, validate: boolean) => void;
}

const SingleName: React.FC<SingleNameProps> = ({
  salesType,
  index,
  onValidation,
}) => {
  const [firstname, setFirstname] = useState<string>("");
  const [surname, setSurname] = useState<string>("");
  const [birthday, setBirthday] = useState<Moment>();
  const [, translations] = useLocale();

  const checkValid = useCallback(
    (values: string[]) => {
      const notValid = values.findIndex((val) => !val || val === "") >= 0;
      onValidation(salesType, index, !notValid);
    },
    [onValidation, salesType, index]
  );

  const onChangeFirstname = useCallback(
    (e) => {
      setFirstname(e.target.value);
      checkValid([
        e.target.value,
        surname,
        window.adt_ticket_data.provider === "TICKETONE"
          ? birthday?.toISOString()
          : "a",
      ]);
    },
    [setFirstname, checkValid, surname, birthday]
  );
  const onChangeSurname = useCallback(
    (e) => {
      setSurname(e.target.value);
      checkValid([
        e.target.value,
        firstname,
        window.adt_ticket_data.provider === "TICKETONE"
          ? birthday?.toISOString()
          : "a",
      ]);
    },
    [setSurname, checkValid, firstname, birthday]
  );
  const onChangeBirthday = useCallback(
    (val: Moment | null, dateString: string) => {
      setBirthday(val ? val : undefined);
      checkValid([dateString, surname, firstname]);
    },
    [setBirthday, checkValid, surname, firstname]
  );

  const disabledDate = useCallback((currentDate: Moment): boolean => {
    return currentDate && currentDate.valueOf() >= Date.now();
  }, []);

  const isTickaProvider = window.adt_ticket_data.provider === "TICKA";
  const isTicketoneProvider = window.adt_ticket_data.provider === "TICKETONE";

  const classname = ["name-panel"];
  if (isTicketoneProvider) classname.push("name-panel-ticketone");

  return (
    <div className={classname.join(" ")}>
      <div className="field_group">
        <label 
          id={"label_firstname_" + salesType + "_" + index}
          htmlFor={"firstname_" + salesType + "_" + index}
        >
          {translations['final.firstname']}
        </label>
        <Input
          id={"firstname_" + salesType + "_" + index}
          aria-labelledby={"label_firstname_" + salesType + "_" + index + " title_" + salesType}
          value={firstname}
          placeholder={translations['final.firstname']}
          onChange={onChangeFirstname}
        />
      </div>
      <div className="field_group">
        <label
          id={"label_lastname_" + salesType + "_" + index}
          htmlFor={"lastname_" + salesType + "_" + index}
        >
          {translations['final.lastname']}
        </label>
        <Input
          id={"lastname_" + salesType + "_" + index}
          aria-labelledby={"label_lastname_" + salesType + "_" + index + " title_" + salesType}
          value={surname}
          placeholder={translations['final.lastname']}
          onChange={onChangeSurname}
        />
      </div>
      {isTicketoneProvider && (
        <>
          <div className="field_group">
            <label
              id={"expLabel_" + salesType + "_" + index}
              htmlFor={"dp_" + salesType + "_" + index}
            >
              {translations['final.birthday']}
            </label>
            <DatePicker
              id={"dp_" + salesType + "_" + index}
              aria-labelledby={"expLabel_" + salesType  + "_" + index + " title_" + salesType}
              aria-describedby={"expDesc_" + salesType + "_" + index}
              value={birthday}
              placeholder={translations['final.birthday']}
              disabledDate={disabledDate}
              onChange={onChangeBirthday}
              onFocus={() => {
                const el = document.getElementById("expDesc_" + salesType + "_" + index);
                if (el) el.style.display = "block";
              }}
              onBlur={() => {
                const el = document.getElementById("expDesc_" + salesType + "_" + index);
                if (el) el.style.display = "none";
              }}
            />
            <Input
              type="hidden"
              name="names[]"
              value={`${salesType}_${firstname}_${surname}_${birthday?.format(
              "DD.MM.yyyy"
              )}`}
            />
            <p id={"expDesc_" + salesType + "_" + index} style={{ display: "none" }}>{translations['final.date_format']}</p>
          </div>
        </>
      )}
      {isTickaProvider && (
        <>
          <Input
            type="hidden"
            name="names[]"
            value={`${salesType}_${firstname}_${surname}`}
          />
        </>
      )}
    </div>
  );
};
export default SingleName;
